module.exports = __webpack_public_path__ + "static/media/man-mobile.2afa7771.svg";